import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.contentTarget.addEventListener("keydown", this.handleKeydown.bind(this))
  }

  disconnect() {
    this.contentTarget.removeEventListener("keydown", this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    // Check if Enter was pressed without Shift (Shift+Enter allows for newlines)
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  clearContent() {
    this.contentTarget.value = ""
  }
}
